import styled from "styled-components";

const Spacer = styled.div`
  height: 40px;
`;

export default Spacer;
